import makeLevel from '../makeLevel.js';
import * as powerups from '../../powerups.js';

export default makeLevel([
	'                    ',
	'                    ',
	'                    ',
	'      ********      ',
	'     **bbbrrr**     ',
	'    **bbbbrrrr**    ',
	'   **bbbbbrrrrr**   ',
	'   *bbb!bbrr!rrr*   ',
	'   *bbbb!br!rrrr*   ',
	'   *bbbbb!!rrrrr*   ',
	'   *ggggg!!yyyyy*   ',
	'   *gggg!gy!yyyy*   ',
	'   *ggg!ggyy!yyy*   ',
	'   **gggggyyyyy**   ',
	'    **ggggyyyy**    ',
	'     **gggyyy**     ',
	'      ********      ',
	'                    ',
	'                    ',
	'                    ',
], [
    {
        "2": powerups.ballSpeedUp,
        "7": powerups.ballSpeedUp,
        "9": powerups.paddleShrink,
        "10": powerups.ballExploding,
        "11": powerups.ballSpeedUp,
        "13": powerups.paddleGrow,
        "14": powerups.instaDeath,
        "15": powerups.paddleLasers,
        "16": powerups.ballExtra,
        "18": powerups.paddleGrow,
        "20": powerups.ballExtra,
        "21": powerups.ballSpeedDown,
        "22": powerups.skipLevel,
        "39": powerups.ballExtra,
        "40": powerups.paddleShrink,
        "47": powerups.instaDeath,
        "58": powerups.ballExploding,
        "64": powerups.paddleSticky,
        "78": powerups.ballSpeedUp,
        "79": powerups.paddleSticky,
        "81": powerups.paddleShrink,
        "88": powerups.paddleGrow,
        "90": powerups.paddleGrow,
        "91": powerups.ballSpeedUp,
        "99": powerups.ballExploding,
        "100": powerups.ballUnstopable,
        "102": powerups.ballExploding,
        "103": powerups.ballExtra,
        "105": powerups.ballExploding,
        "110": powerups.extraLive,
        "111": powerups.paddleShrink,
        "129": powerups.paddleMini,
        "143": powerups.ballExtra,
        "144": powerups.ballExtra,
        "147": powerups.ballExtra,
        "149": powerups.paddleGrow,
        "153": powerups.paddleShrink,
        "156": powerups.instaDeath,
        "158": powerups.paddleGrow,
        "166": powerups.ballExtra,
        "167": powerups.ballSpeedUp
    },
    {
        "8": powerups.paddleSticky,
        "11": powerups.instaDeath,
        "12": powerups.skipLevel,
        "15": powerups.ballExploding,
        "16": powerups.ballSpeedUp,
        "38": powerups.paddleShrink,
        "39": powerups.ballSpeedUp,
        "48": powerups.ballSpeedUp,
        "50": powerups.paddleShrink,
        "61": powerups.paddleShrink,
        "62": powerups.ballSpeedDown,
        "65": powerups.paddleSticky,
        "67": powerups.lightning,
        "70": powerups.ballSpeedUp,
        "76": powerups.ballSpeedUp,
        "79": powerups.ballExtra,
        "80": powerups.paddleLasers,
        "85": powerups.ballSpeedUp,
        "86": powerups.instaDeath,
        "93": powerups.ballSpeedUp,
        "97": powerups.paddleGrow,
        "98": powerups.ballSpeedDown,
        "103": powerups.ballExtra,
        "106": powerups.ballExploding,
        "112": powerups.ballSpeedDown,
        "116": powerups.paddleShrink,
        "122": powerups.paddleGrow,
        "123": powerups.paddleShrink,
        "125": powerups.ballSpeedDown,
        "127": powerups.ballSpeedDown,
        "140": powerups.paddleGrow,
        "144": powerups.paddleShrink,
        "145": powerups.paddleShrink,
        "150": powerups.paddleShrink,
        "151": powerups.ballExploding,
        "153": powerups.paddleLasers,
        "154": powerups.ballUnstopable,
        "156": powerups.paddleShrink,
        "159": powerups.ballExtra,
        "165": powerups.ballSpeedUp,
        "171": powerups.paddleGrow
    },
    {
        "19": powerups.paddleShrink,
        "23": powerups.ballSpeedDown,
        "27": powerups.ballUnstopable,
        "29": powerups.ballExploding,
        "34": powerups.paddleShrink,
        "40": powerups.ballSpeedUp,
        "43": powerups.ballUnstopable,
        "44": powerups.ballSpeedUp,
        "47": powerups.paddleSticky,
        "52": powerups.weakenBlocks,
        "56": powerups.paddleLasers,
        "57": powerups.paddleSticky,
        "63": powerups.ballExtra,
        "64": powerups.paddleGrow,
        "71": powerups.paddleLasers,
        "73": powerups.paddleGrow,
        "76": powerups.paddleShrink,
        "83": powerups.ballSpeedUp,
        "87": powerups.ballExploding,
        "90": powerups.paddleSticky,
        "97": powerups.ballExploding,
        "102": powerups.paddleShrink,
        "105": powerups.instaDeath,
        "109": powerups.paddleGrow,
        "115": powerups.ballUnstopable,
        "121": powerups.paddleGrow,
        "124": powerups.ballSpeedDown,
        "129": powerups.ballSpeedDown,
        "130": powerups.paddleShrink,
        "132": powerups.ballExtra,
        "133": powerups.paddleGrow,
        "135": powerups.ballSpeedUp,
        "136": powerups.ballExtra,
        "147": powerups.ballExtra,
        "150": powerups.ballSpeedDown,
        "154": powerups.ballUnstopable,
        "161": powerups.skipLevel,
        "162": powerups.ballSpeedUp,
        "164": powerups.ballSpeedDown,
        "171": powerups.weakenBlocks
    },
    {
        "8": powerups.ballSpeedUp,
        "17": powerups.paddleGrow,
        "27": powerups.ballUnstopable,
        "38": powerups.paddleSticky,
        "42": powerups.lightning,
        "45": powerups.paddleShrink,
        "48": powerups.ballSpeedUp,
        "55": powerups.paddleLasers,
        "58": powerups.ballSpeedDown,
        "60": powerups.paddleGrow,
        "68": powerups.instaDeath,
        "70": powerups.ballSpeedDown,
        "72": powerups.paddleShrink,
        "73": powerups.paddleLasers,
        "78": powerups.ballSpeedUp,
        "95": powerups.instaDeath,
        "97": powerups.paddleMini,
        "101": powerups.ballExtra,
        "106": powerups.weakenBlocks,
        "112": powerups.paddleSticky,
        "127": powerups.paddleLasers,
        "129": powerups.paddleGrow,
        "130": powerups.ballExploding,
        "142": powerups.weakenBlocks,
        "149": powerups.paddleLasers,
        "156": powerups.ballSpeedUp,
        "157": powerups.ballSpeedDown,
        "164": powerups.ballExtra,
        "168": powerups.instaDeath,
        "170": powerups.ballUnstopable
    },
    {
        "1": powerups.skipLevel,
        "8": powerups.paddleLasers,
        "10": powerups.paddleShrink,
        "11": powerups.paddleSticky,
        "14": powerups.ballSpeedUp,
        "22": powerups.paddleGrow,
        "35": powerups.paddleSticky,
        "37": powerups.ballSpeedUp,
        "48": powerups.paddleGrow,
        "51": powerups.paddleShrink,
        "53": powerups.paddleShrink,
        "60": powerups.ballExtra,
        "61": powerups.paddleGrow,
        "64": powerups.paddleGrow,
        "66": powerups.paddleGrow,
        "67": powerups.paddleLasers,
        "79": powerups.paddleMini,
        "89": powerups.ballUnstopable,
        "93": powerups.paddleSticky,
        "96": powerups.ballUnstopable,
        "98": powerups.ballSpeedUp,
        "106": powerups.paddleMini,
        "107": powerups.ballExtra,
        "111": powerups.ballSpeedDown,
        "114": powerups.paddleShrink,
        "115": powerups.ballSpeedDown,
        "133": powerups.ballUnstopable,
        "135": powerups.skipLevel,
        "139": powerups.paddleShrink,
        "140": powerups.ballExtra,
        "146": powerups.paddleLasers
    },
    {
        "2": powerups.paddleGrow,
        "5": powerups.paddleShrink,
        "7": powerups.lightning,
        "14": powerups.ballExtra,
        "16": powerups.ballSpeedDown,
        "18": powerups.ballExtra,
        "19": powerups.ballExploding,
        "25": powerups.lightning,
        "26": powerups.paddleGrow,
        "28": powerups.ballExtra,
        "32": powerups.lightning,
        "35": powerups.paddleLasers,
        "38": powerups.weakenBlocks,
        "40": powerups.ballUnstopable,
        "44": powerups.paddleSticky,
        "46": powerups.ballSpeedDown,
        "49": powerups.paddleGrow,
        "51": powerups.paddleGrow,
        "63": powerups.paddleMini,
        "73": powerups.paddleGrow,
        "76": powerups.ballExploding,
        "91": powerups.ballSpeedDown,
        "93": powerups.paddleLasers,
        "94": powerups.ballSpeedDown,
        "99": powerups.ballExtra,
        "106": powerups.ballUnstopable,
        "107": powerups.paddleLasers,
        "113": powerups.ballExtra,
        "116": powerups.lightning,
        "120": powerups.paddleGrow,
        "124": powerups.paddleShrink,
        "136": powerups.paddleShrink,
        "137": powerups.paddleGrow,
        "138": powerups.paddleLasers,
        "139": powerups.paddleShrink,
        "147": powerups.paddleGrow,
        "151": powerups.paddleGrow,
        "154": powerups.ballExtra,
        "157": powerups.paddleShrink,
        "159": powerups.ballExtra,
        "162": powerups.paddleGrow,
        "166": powerups.lightning
    },
    {
        "2": powerups.paddleSticky,
        "3": powerups.ballExtra,
        "4": powerups.lightning,
        "5": powerups.paddleGrow,
        "10": powerups.instaDeath,
        "15": powerups.ballSpeedDown,
        "20": powerups.ballExtra,
        "22": powerups.paddleShrink,
        "24": powerups.weakenBlocks,
        "27": powerups.paddleGrow,
        "39": powerups.paddleSticky,
        "44": powerups.paddleGrow,
        "46": powerups.ballSpeedUp,
        "51": powerups.ballSpeedDown,
        "56": powerups.ballExtra,
        "60": powerups.paddleShrink,
        "63": powerups.paddleShrink,
        "74": powerups.ballUnstopable,
        "81": powerups.ballExtra,
        "86": powerups.ballSpeedDown,
        "87": powerups.paddleShrink,
        "99": powerups.paddleSticky,
        "102": powerups.paddleSticky,
        "105": powerups.ballSpeedDown,
        "112": powerups.paddleGrow,
        "115": powerups.paddleGrow,
        "117": powerups.paddleLasers,
        "118": powerups.lightning,
        "119": powerups.weakenBlocks,
        "121": powerups.paddleGrow,
        "126": powerups.ballExtra,
        "130": powerups.ballUnstopable,
        "136": powerups.ballExploding,
        "144": powerups.ballSpeedDown,
        "151": powerups.ballExploding,
        "161": powerups.paddleLasers
    },
    {
        "0": powerups.paddleGrow,
        "14": powerups.paddleShrink,
        "17": powerups.ballUnstopable,
        "26": powerups.ballExtra,
        "27": powerups.ballSpeedDown,
        "36": powerups.paddleMini,
        "37": powerups.ballExtra,
        "39": powerups.ballUnstopable,
        "44": powerups.paddleMini,
        "63": powerups.ballUnstopable,
        "68": powerups.paddleShrink,
        "71": powerups.paddleGrow,
        "72": powerups.ballSpeedDown,
        "75": powerups.ballExploding,
        "76": powerups.instaDeath,
        "77": powerups.paddleGrow,
        "79": powerups.paddleSticky,
        "81": powerups.paddleGrow,
        "82": powerups.ballExtra,
        "86": powerups.paddleShrink,
        "92": powerups.ballSpeedUp,
        "95": powerups.paddleShrink,
        "97": powerups.ballSpeedUp,
        "100": powerups.paddleMini,
        "114": powerups.paddleGrow,
        "116": powerups.ballExtra,
        "118": powerups.ballUnstopable,
        "120": powerups.ballExtra,
        "123": powerups.paddleShrink,
        "128": powerups.ballSpeedDown,
        "129": powerups.paddleShrink,
        "142": powerups.paddleShrink,
        "145": powerups.ballSpeedUp,
        "147": powerups.ballExploding,
        "148": powerups.ballExtra,
        "150": powerups.ballSpeedUp,
        "155": powerups.paddleShrink,
        "169": powerups.paddleGrow
    }
]);
